import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CompraService } from '../../../services/compra.service';
import { Compra } from '../../../models/compra';
import { ProveedorModalComponent } from '../../modals/proveedor-modal/proveedor-modal.component';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ProveedorService } from '../../../services/proveedor.service';
import { Proveedor } from '../../../models/proveedor';
//import { AsyncLocalStorage } from 'angular-async-local-storage';
import * as numeral from 'numeral';
import { Cheque } from '../../../models/cheque';
import { Tarjeta } from '../../../models/tarjeta';
import { Retencion } from '../../../models/retencion';
import { ParametroService } from '../../../services/parametro.service';

import { FormaPago } from '../../../models/forma-pago';
import { Validation } from '../../../config/validation';
import { PagoService } from '../../../services/pago.service';
import { Pago } from '../../../models/pago';
import { PagoDetalle } from '../../../models/pago_detalle';
import { SessionService } from '../../../services/session.service';
import { SweetMessage } from '../../../config/sweet-message';
import * as moment from 'moment';
import { DatosPagosComponent } from '../../../controls/datos-pago/datos-pago.component';
import { UtilsService } from '../../../services/utils.service';
import { PagoGrupo } from '../../../models/pago-grupo';
import { ReporteModalComponent } from '../../modals/reporte-modal/reporte-modal.component';
import { Transferencia } from '../../../models/transferencia';
import { ParametroContabilidadService } from '../../../services/parametro-contabilidad.service';
import { ParametroContabilidad } from '../../../models/parametro-contabilidad';
import { PeriodoContable } from '../../../models/periodo-contable';
import { PeriodoContableService } from '../../../services/periodo-contable.service';
import { AsientoContable } from '../../../models/asiento-contable';
import { AsientoContableDetalle } from '../../../models/asiento-contable-detalle';


@Component({
  selector: 'app-pago-grupo',
  templateUrl: './pago-grupo.component.html',
  styleUrls: ['./pago-grupo.component.css'],
  providers: [CompraService,PagoService,SessionService,ParametroService,ProveedorService,ParametroContabilidadService,PeriodoContableService]
})
export class PagoGrupoComponent implements OnInit {
	public compras: Array<Compra>;
	public bsModalRef: BsModalRef;
	public proveedor: Proveedor;
	public formasPago: Array<FormaPago>;
	public vl: Validation;
	public compra: Compra;
	public total_pago: number;
	public cambio: number;
	public pago: Pago;
	public pago_grupo: PagoGrupo;
	public msg: SweetMessage;
	public total_cobro: number;
	public loading = false;
	public cheques: Array<Cheque>;
	public tarjetas: Array<Tarjeta>;
	public transferencias: Array<Transferencia>;
	public valorefectivo: number;
	//public fecha_cobro;
	public tipo : String;
	public numero_decimales: number;
	public format_decimal: String;
	public total_facturas: any;
	public total:any;
	public total_retencion:any;
	public total_a_pagar:any;
	public total_pagado:any;
	public total_saldo:any;
	public fecha_pago: any;
	public compra_selected: boolean;
	public selectAll: boolean;
	public guardado: boolean;
	public total_cheque: number = 0;
    public total_tarjeta: number = 0;
	public total_efectivo: number = 0;
	public proveedor_search:boolean;
	public proveedor_id: String;
	public pago_id:String;
	public Mod_Cartera: string;
	public Mod_Contabilidad: string;
	public parametrosContabilidad: Array<ParametroContabilidad>;
	public periodoContable: PeriodoContable;
  @ViewChild(DatosPagosComponent) datosPagos: DatosPagosComponent;
	constructor(

		private activatedRoute: ActivatedRoute,
        public pagoService: PagoService,
        public ss: SessionService,
        public utils: UtilsService,
		public compraService: CompraService,
		private NavRoute: Router,
		private modalService: BsModalService,
		public proveedorService: ProveedorService,
		public parametroService: ParametroService,
		private parametroContabilidadService: ParametroContabilidadService,
		
        private periodoContableService: PeriodoContableService,
		//private storage: AsyncLocalStorage,
	) {		
		this.compras = [];
		this.proveedor = new Proveedor();
		this.numero_decimales = 2;
		this.format_decimal = "0,0.00";
		this.total_facturas = 0;
		 this.total =0;
		 this.total_retencion = 0;
		 this.total_a_pagar = 0;
		 this.total_pagado = 0;
		this.total_pago = 0;
		this.total_saldo = 0;

		this.formasPago = [];
        this.vl = new Validation();
        this.compra  = new Compra();
        this.cambio = 0;
		this.pago = new Pago();
		this.pago_grupo = new PagoGrupo();
        this.msg = new SweetMessage();
        //this.total_cobro = 0;
        this.cheques = [];
		this.tarjetas = [];
		this.transferencias = [];
		this.valorefectivo = 0;
		let now = moment();
        this.fecha_pago = moment(now.format(), moment.ISO_8601).format();
	//	this.fecha_pago = moment();
		this.compra_selected = false;
		this.selectAll = false;
		this.guardado = false;
		this.proveedor_search = false;
		this.proveedor_id = "";
		this.pago_id = "";
		this.Mod_Cartera = this.ss.getData("mod_cartera");
		this.Mod_Contabilidad = this.ss.getData("mod_contabilidad");
		this.parametrosContabilidad = [];
		this.periodoContable = new PeriodoContable();
 	}

	ngOnInit() {
		this.loading = true;
		let p1 = this.getParamNumeroDecimales();
		let p2 = null;
		if( this.Mod_Cartera && this.Mod_Contabilidad ) {
			p2 = this.getParametroContabilidadCompras();
		}
		this.loading = true;
		Promise.all([p1, p2]).then(
			res => this.loading = false,
			err => this.loading = false
		);
		

		/*this.loading = true;
        let p1 = this.getParamNumeroDecimales();

        Promise.all([p1]).then(
            res => this.loading = false,
            err => this.loading = false
		);
		this.total_facturas = 0;
		*/
	}

	getParametroContabilidadCompras(){
        return new Promise((resolve, reject) => {
			// let qs = "?in[id]=9,11,16,17,18,20,22&embed=cuentacontable";
			let qs = "?tipo=C&in[seccion]=IM,P&embed=cuentacontable";
			this.parametroContabilidadService.getAll(qs).subscribe(
				res => {
					let is_confirmedParametros = true;
					this.parametrosContabilidad.forEach(parametroContabilidad => {
						if( parametroContabilidad.cuenta_contable_id == null ){
							is_confirmedParametros = false;
							return false;
						}
					});
					if(!is_confirmedParametros){
						this.msg.showMessage('error-message', "Por favor, confirmar los parámetros de las cuentas contables.");
					}else{
						this.parametrosContabilidad = res.data;
					}
					resolve(true);
				},
				err => {
					reject(err);
				}
			);
            
        });
	}
	getPeriodoActual(){
        return new Promise((resolve, reject) => {
            let qs = "?periodo=" + moment().format('YYYY');
            this.periodoContableService.getPeriodoActual(qs).subscribe(
                res => {
                    this.periodoContable = res;
                    resolve(true);
                },
                err => {
                    reject(err);
                }
            );
        });
	}
	
	setValueAsientoContable(){
        
       
        let asientoContableCobros = new AsientoContable();
        asientoContableCobros.fecha_emision = this.pago.fecha_pago;
        asientoContableCobros.tipo_comprobante_id = null;
        asientoContableCobros.periodo_contable_id = this.periodoContable.id;
		asientoContableCobros.numero_documento = null;
		asientoContableCobros.descripcion = this.proveedor.razon_social;
        // asientoContableCobros.descripcion = this.proveedor.razon_social;
        asientoContableCobros.empresa_id = this.pago.empresa_id;
        asientoContableCobros.usuario_id = this.pago.usuario_id;
        asientoContableCobros.total = this.total_pago;
        asientoContableCobros.status = 'A';
		let valor_cheque= 0;
		let valor_tarjetas = 0;
		let valor_transferencias = 0;
		this.cheques.forEach(c=> {
			valor_cheque += Number(c.valor);
		});
		this.tarjetas.forEach(c=> {
			valor_tarjetas += Number(c.valor);
		});
		this.transferencias.forEach(c=> {
			valor_transferencias += Number(c.valor);
		});
        this.parametrosContabilidad.forEach(parametroContabilidad => {
            let asientoContableDetalle = new AsientoContableDetalle;
            asientoContableDetalle.empresa_id = asientoContableCobros.empresa_id;
			asientoContableDetalle.usuario_id = asientoContableCobros.usuario_id;
		
			if(parametroContabilidad.id == '27'){
                let total = Number(this.total_pago)*0.88;
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?total:0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?total:0;
				asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
				asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
				asientoContableCobros.detalle.unshift(asientoContableDetalle);   
            }
            
            if(parametroContabilidad.id == '19'){
                let total = Number(this.total_pago)*0.12;
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?total:0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?total:0;
				asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
				asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
				asientoContableCobros.detalle.push(asientoContableDetalle);   
			}
                asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
                asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
			if( parametroContabilidad.id == "23" && this.valorefectivo > valor_cheque && this.valorefectivo > valor_tarjetas && this.valorefectivo > valor_transferencias ) {
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.total_pago:0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.total_pago:0;
				asientoContableCobros.detalle.push(asientoContableDetalle);
			}
			else if( parametroContabilidad.id == "24" && valor_cheque > this.valorefectivo && valor_cheque > valor_tarjetas && valor_cheque > valor_transferencias ) {
				
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.total_pago:0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.total_pago:0;
				asientoContableCobros.detalle.push(asientoContableDetalle);
			}
			else if(  parametroContabilidad.id == "25" && valor_tarjetas > this.valorefectivo && valor_tarjetas > valor_cheque && valor_tarjetas > valor_transferencias ) {
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.total_pago:0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.total_pago:0;
				asientoContableCobros.detalle.push(asientoContableDetalle);
			}
			else if( parametroContabilidad.id == "26"  && valor_transferencias > this.valorefectivo && valor_transferencias > valor_tarjetas && valor_transferencias > valor_cheque ) {
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.total_pago:0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.total_pago:0;
				asientoContableCobros.detalle.push(asientoContableDetalle);
			}else if( parametroContabilidad.id == "23") {
                asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.total_pago:0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.total_pago:0;
				asientoContableCobros.detalle.push(asientoContableDetalle);
			}
				
		});
		this.pago.asientosContables.push(asientoContableCobros);
    }

	ngOnDestroy(){
	}

	getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";

                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
    }

    get formatDecimal(){
        return this.format_decimal;
    }

	onSearchProveedor(event) {
		if( event.keyCode === 13 ){
			if( this.proveedor.dni.toString().trim().length == 0 ){
				this.proveedor = new Proveedor();
				this.compras = [];
				return;
			}else{
				this.proveedorService.getByDni(this.proveedor.dni).subscribe(
					res => {
						this.loading = false;
						if (res.length > 0) {
							this.proveedor = res[0];
							this.compras = [];
						
							this.getComprasCredito(this.proveedor.id);
						}else{
							this.proveedor = new Proveedor();
							this.compras = [];
							
							this.openDialogProveedor();
						}
					},
					err => {
						this.loading = false;
						this.compras = [];
						this.openDialogProveedor();
						
					}
				);
			}
		}
  }


	openDialogProveedor() {
		
		this.proveedor_search=false;
		const initialState = {pagos_pendientes: true};
		this.bsModalRef = this.modalService.show(ProveedorModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.sendProveedor.take(1).subscribe(proveedor => {
			this.proveedor = proveedor;
			this.compras = [];
			//this.storage.setItem('cobroClienteSearch',this.cliente).subscribe()
			this.getComprasCredito(this.proveedor.id);	
		});
	}

	getComprasCredito(proveedor_id){
		this.loading = true;
		this.compraService.getAll("?embed=tipocomprobante,retencion&tipo=CR&estado_pago=P&proveedor_id="+proveedor_id).subscribe(
			res => {
				if( res.data.length ){
					this.compras = res.data;
					this.compras.forEach((compra: Compra) => {
						if( !compra.retencion ){
							compra.retencion = new Retencion()
						}
					});
			
					this.total_facturas = 0;
					this.calcularTotalFacturas();
					//this.storage.setItem('cobroVentasSearch',this.ventas).subscribe()
				}else{
					this.compras = [];
				}
				this.loading = false;
			},
			err => {
				this.loading = false;
				this.compras = [];
			}
		);
  }

  onSubmit(){
	this.msg.showMessage('delete-confirm-message', "¿Está seguro de confirmar el pago?").then(
		res => {
			this.setValueEntity();
			
			if( this.Mod_Cartera && this.Mod_Contabilidad ){

				this.getPeriodoActual().then(
					res => {
						this.setValueAsientoContable();
						   this.savePago();   
					}
				);
			}else {
			   this.savePago();   
			}
		
		});
	}
	savePago(){
		this.loading = true;
			this.proveedor_search=false;
		this.pagoService.saveGrupo(this.pago).subscribe(
			res => {
				this.msg.showMessage('success-message', res.message);
				//this.venta = new Venta();
				//this.pago_grupo = new PagoGrupo();
				this.guardado = true;
				this.proveedor_search=true;
				this.pago = new Pago();
				this.pago_id = JSON.parse(res.response._body).id;	
				this.cambio = 0;
				this.total_pago = 0;
				this.datosPagos.total_cheque = 0;
				this.datosPagos.total_tarjeta = 0;
				this.datosPagos.total_efectivo = 0;
				this.datosPagos.total_transferencia = 0;
				this.cheques = [];
				this.tarjetas = [];
				this.transferencias = [];
				this.valorefectivo = 0;
				this.proveedor_id = this.proveedor['id'];
				this.proveedor = new Proveedor();
				let now = moment();
					 this.fecha_pago = moment(now.format(), moment.ISO_8601).format();
				this.compras = [];
				this.total_facturas = 0;
				this.total = 0;
				this.total_retencion = 0;
				this.total_a_pagar = 0;
				this.total_pagado = 0;
				this.total_saldo = 0;
				this.loading = false;
				
			},
			err => {
				this.loading = false;
				this.msg.showMessage('error-message',err);
			}
		);
	}

  
  
  setValueEntity(){
	this.pago.fecha_pago = moment(this.fecha_pago).format("YYYY-MM-DD");
	//this.pago.saldo = this.total_facturas - this.compra.abonado;
	this.pago.saldo = this.total_facturas;
	this.pago.recibido = this.total_pago;
	this.pago.cambio = 0;
	//this.pago.compra_id = this.compra.id;

	this.pago.detalle = [];
	//this.pago.caja_id = this.ss.getData("caja_id");
	this.pago.empresa_id = this.ss.getData("empresa_id");
	this.pago.sucursal_id = this.ss.getData("sucursal_id");
	this.pago.usuario_id = this.ss.getData("usuario_id");

	if( this.valorefectivo > 0 ){
		let pago_detalle = new PagoDetalle();
		pago_detalle.valor = this.valorefectivo;
		pago_detalle.forma_pago_id = "1"; // EFECTIVO
		pago_detalle.empresa_id = this.ss.getData("empresa_id");
		pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
		pago_detalle.usuario_id = this.ss.getData("usuario_id");
		this.pago.detalle.push(pago_detalle);
	}

	this.cheques.forEach(ch => {
		let pago_detalle = new PagoDetalle();

		pago_detalle.fecha_cheque = ch.fecha;
		pago_detalle.numero_cta = ch.cuenta;
		pago_detalle.numero_cheque = ch.numero;
		pago_detalle.banco_id = ch.banco_id;
		pago_detalle.observacion = ch.observacion;
		pago_detalle.valor = ch.valor;
		pago_detalle.forma_pago_id = ch.forma_pago_id; // CHEQUE
		pago_detalle.empresa_id = this.ss.getData("empresa_id");
		pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
		pago_detalle.usuario_id = this.ss.getData("usuario_id");
		this.pago.detalle.push(pago_detalle);
	});

	this.tarjetas.forEach(tr => {
		let pago_detalle = new PagoDetalle();

		pago_detalle.debito_credito = tr.debito_credito;
		pago_detalle.observacion = tr.observacion;
		pago_detalle.tipo_tarjeta_id = tr.tipo_id;
		pago_detalle.valor = tr.valor;
		pago_detalle.plazo = tr.plazo;
		pago_detalle.tiempo = tr.tiempo;
		pago_detalle.debito_credito = "C";
		pago_detalle.forma_pago_id = tr.forma_pago_id; // TARJETA
		pago_detalle.empresa_id = this.ss.getData("empresa_id");
		pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
		pago_detalle.usuario_id = this.ss.getData("usuario_id");
		this.pago.detalle.push(pago_detalle);
	});

	this.transferencias.forEach(tr => {
		let pago_detalle = new PagoDetalle();

		pago_detalle.fecha_transferencia = tr.fecha;
		pago_detalle.numero_cta = tr.cuenta;
		pago_detalle.numero_comprobante = tr.numero;
		pago_detalle.banco_id = tr.banco_id;
		pago_detalle.observacion = tr.observacion;

		pago_detalle.valor = tr.valor;
		pago_detalle.forma_pago_id = tr.forma_pago_id; // TRANSFERENCIA
		pago_detalle.empresa_id = this.ss.getData("empresa_id");
		pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
		pago_detalle.usuario_id = this.ss.getData("usuario_id");
		this.pago.detalle.push(pago_detalle);
	});

	this.compras.forEach((compra: any, index: number) => {
		if( compra.selected ){

			this.compra.usuario_id = this.ss.getData("usuario_id");
			this.compra.empresa_id = this.ss.getData("empresa_id");

			this.pago.grupo.push(compra);
		}
	
	});
}
  
	isFormValid(){
		if( this.fecha_pago.toString().trim().length  === 0 ){
			return false;
		}
		if( this.total_pago <= 0 ){
			return false;
		}
		if( this.total_facturas == 0 ){
			return false;
		}
		if( this.total_pago != this.total_facturas ){
			return false;
		}
		return true;
	}


	calcularTotalFacturas(){
		this.total_facturas = 0;
		this.total =0;
		this.total_retencion = 0;
		this.total_a_pagar = 0;
		this.total_pagado = 0;
		this.total_pago = 0;
		this.total_saldo = 0;
		this.compras.map(compra => {
			this.total += (parseFloat(compra.total.toString()));
			this.total = this.utils.redondear(this.total,this.numero_decimales);
			this.total_retencion += (parseFloat(compra.retencion.total.toString()));
			this.total = this.utils.redondear(this.total,this.numero_decimales);
			this.total_a_pagar += (parseFloat(compra.total.toString()) - parseFloat(compra.retencion.total.toString()));
			this.total_a_pagar = this.utils.redondear(this.total_a_pagar,this.numero_decimales);
			this.total_pagado += (parseFloat(compra.abonado.toString()));
			this.total_pagado = this.utils.redondear(this.total_pagado,this.numero_decimales);
			this.total_saldo += (parseFloat(compra.total.toString()) - parseFloat(compra.abonado.toString()) - parseFloat(compra.retencion.total.toString()));
			this.total_saldo = this.utils.redondear(this.total_saldo,this.numero_decimales);
			if(compra.selected){
				this.total_facturas += (compra.total - compra.abonado - compra.retencion.total);
				this.total_facturas = this.utils.redondear(this.total_facturas,this.numero_decimales);
				
				//this.calcularCambio();
			}
			
		})
	}
	
	onChangeEfectivo(total){
		this.valorefectivo = total;
	}

	calcSaldo(compra){
		let saldo = compra.total - compra.abonado;

		if( compra.retencion ){
			saldo = saldo - compra.retencion.total;
		}

		//return saldo = Math.round(saldo * 100) / 100;
		return saldo = this.utils.redondear(saldo,this.numero_decimales);
	}
	
	calcularTotal(total){
		this.total_pago = total;
		this.total_pago = this.utils.redondear(this.total_pago,this.numero_decimales);
	//	this.calcularCambio();
	}
/*
	calcularCambio(){
		this.cambio = (this.total_pago > this.total_facturas?(this.total_pago - this.total_facturas):0);
		this.cambio = this.utils.redondear(this.cambio,this.numero_decimales);
	}
*/	
	onShow(id){
		this.NavRoute.navigate(['/compras/compras-show/' + id]);
	}

	onPay(id){
		this.NavRoute.navigate(['/compras/pago/' + id]);
	}
	
	numeroFactura(venta){
        return venta.serie + "-" + venta.punto_emision + "-" + venta.secuencial;
	}

	onSelectAll(){
		this.compras.map(compra => compra.selected = this.selectAll);

		this.calcularTotalFacturas()
	}

	imprimirComprobante(){
        let params = [];        
        params["empresa_id"] = this.ss.getData('empresa_id');
        params["usuario_id"] = this.ss.getData('usuario_id');

		if(this.fecha_pago ){
			params["fecha_pago"]=this.fecha_pago;
		}			
		
		if(this.proveedor_id){
		
			params["proveedor_id"] = this.proveedor_id;
		}
	
		if(this.pago_id){
			params["pago_id"] = this.pago_id;
		}
	
		

        let qs = [];
        for(let key in params){
            let str = key + "=" + params[key];
            qs.push(str);
        }
		
		const initialState = { route: "pago", qs: "?" + qs.join("&") + "&dbname=" + this.ss.getData('dbname') };
        this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));
    }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/pago-grupo/pago-grupo.component.ts